// extracted by mini-css-extract-plugin
module.exports = {"btnCancel":"styles_btnCancel__3qi2_","btnOk":"styles_btnOk__35FHO"};